import "./MessageLoader.scss";

export const MessageLoader = () => {
  return (
    <div className="loaderMessages">
      <span className="loader"></span>
    </div>
  );
};
